import React from 'react';
import i18n from '../../i18n';

// Top-level safety net — without this, any uncaught render error (a
// malformed Firestore doc, an unexpected null) unmounts the whole app to a
// blank white screen with no way back short of a manual reload.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('Unhandled render error:', error, info?.componentStack);
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div style={{
        minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
        background: 'var(--bg, #f9fafb)', padding: 24,
      }}>
        <div style={{
          maxWidth: 420, textAlign: 'center', background: 'var(--surface, #fff)',
          border: '1px solid var(--border, #e5e7eb)', borderRadius: 12, padding: '32px 28px',
        }}>
          <h1 style={{ fontSize: 18, fontWeight: 700, color: 'var(--text-1, #111827)', margin: '0 0 8px' }}>
            {i18n.t('common:components.errorBoundary.title', 'Something went wrong')}
          </h1>
          <p style={{ fontSize: 14, color: 'var(--text-3, #6b7280)', margin: '0 0 20px' }}>
            {i18n.t('common:components.errorBoundary.description', 'This page hit an unexpected error. Reloading usually fixes it — if it keeps happening, let us know.')}
          </p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            style={{
              padding: '9px 18px', borderRadius: 8, border: 'none',
              background: 'var(--accent, #10b981)', color: '#fff', fontSize: 14, fontWeight: 600, cursor: 'pointer',
            }}
          >
            {i18n.t('common:components.errorBoundary.reload', 'Reload page')}
          </button>
        </div>
      </div>
    );
  }
}
